import type { ScanView } from "../../api/types.js";
import "./scan-next-cue.css";

export function ScanNextCue({
  scan,
  onReview,
  onCoverage,
}: {
  scan: ScanView;
  onReview: () => void;
  onCoverage: () => void;
}) {
  if (scan.status !== "completed" && scan.status !== "completed_with_errors") return null;
  return (
    <div className="scan-next-cue" data-testid="scan-next-cue">
      <p className="scan-next-cue__hint">Next</p>
      <div className="scan-next-cue__actions">
        <button className="button button--primary" type="button" onClick={onReview}>
          Review pending decisions
        </button>
        <button className="button button--ghost" type="button" onClick={onCoverage}>
          Show coverage gaps
        </button>
      </div>
    </div>
  );
}
